import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const COOKIE_KEY = "spdb_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_KEY);
    if (!stored) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = (accepted: boolean) => {
    setLeaving(true);
    setTimeout(() => {
      localStorage.setItem(COOKIE_KEY, accepted ? "accepted" : "declined");
      setVisible(false);
      setLeaving(false);
    }, 400);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[9999] transition-all duration-400 ${
        leaving ? "opacity-0 translate-y-4" : "opacity-100 translate-y-0"
      }`}
    >
      {/* Backdrop blur strip */}
      <div className="bg-[#0e0e0e]/95 backdrop-blur-md border-t border-white/10">
        <div className="max-w-screen-xl mx-auto px-8 lg:px-16 py-6 flex flex-col sm:flex-row items-start sm:items-center gap-6 justify-between">
          {/* Text */}
          <div className="flex items-start gap-4 flex-1">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-shield-check-line text-gold text-lg" />
            </div>
            <p className="font-sans font-light text-white/75 text-sm leading-relaxed">
              Wir verwenden Cookies, um Ihnen das bestmögliche Erlebnis zu bieten. Durch die weitere Nutzung dieser Website stimmen Sie der Verwendung von Cookies zu.{" "}
              <Link
                to="/datenschutz"
                className="text-gold/90 hover:text-gold transition-colors duration-300 underline underline-offset-2 whitespace-nowrap"
              >
                Datenschutzbestimmungen
              </Link>
            </p>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={() => dismiss(false)}
              className="font-sans text-xs tracking-widest uppercase text-white/40 hover:text-white/70 transition-colors duration-300 px-4 py-2 cursor-pointer whitespace-nowrap"
            >
              Ablehnen
            </button>
            <button
              onClick={() => dismiss(true)}
              className="font-sans text-xs tracking-widest uppercase text-[#0e0e0e] bg-gold hover:bg-gold/90 transition-colors duration-300 px-7 py-3 cursor-pointer whitespace-nowrap"
            >
              Akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
